// src/components/ProductManager.js
import React, { useState, useEffect } from 'react';

// Ya no necesitamos Firebase Storage, así que eliminamos esas importaciones

function ProductManager() {
    const [products, setProducts] = useState([]);
    const [formData, setFormData] = useState({ title: '', description: '', price: 0, imageUrl: '' });
    const [imageFile, setImageFile] = useState(null);
    const [isEditing, setIsEditing] = useState(null);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false); // Para mostrar un estado de carga

    // Variables de Cloudinary desde el archivo .env
    const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

    // Obtener todos los productos al cargar (sin cambios)
    useEffect(() => {
        const fetchProducts = async () => {
            const res = await fetch('https://kifli-api.onrender.com/api/products');
            const data = await res.json();
            setProducts(data);
        };
        fetchProducts();
    }, []);

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImageFile(e.target.files[0]);
        }
    };

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // --- MANEJADOR DE ENVÍO (handleSubmit) ACTUALIZADO ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('Procesando...');

        let finalImageUrl = formData.imageUrl; // Usa la URL existente por defecto (para ediciones)

        // 1. Si hay un archivo nuevo, subirlo a Cloudinary PRIMERO
        if (imageFile) {
            setMessage('Subiendo imagen a Cloudinary...');
            
            const data = new FormData();
            data.append('file', imageFile);
            data.append('upload_preset', UPLOAD_PRESET);

            try {
                const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
                    method: 'POST',
                    body: data
                });
                const file = await res.json();
                
                finalImageUrl = file.secure_url; // Esta es la URL de la imagen en Cloudinary
                
                setMessage('Imagen subida. Guardando producto...');
            } catch (err) {
                setMessage('Error al subir la imagen.');
                setIsLoading(false);
                return;
            }
        }

        const productData = { ...formData, imageUrl: finalImageUrl, price: Number(formData.price) };

        // 2. Determinar si estamos Creando o Editando (sin cambios)
        let url = 'https://kifli-api.onrender.com/api/products';
        let method = 'POST';

        if (isEditing) {
            url = `https://kifli-api.onrender.com/api/products/${isEditing}`;
            method = 'PUT';
        }

        // 3. Enviar datos a NUESTRO backend (sin cambios)
        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(productData),
            });
            const data = await res.json();
            setMessage(data.message || 'Producto guardado.');
        } catch (err) {
            setMessage('Error al guardar el producto en nuestro servidor.');
        }
        
        // 4. Limpiar y recargar (sin cambios)
        setIsLoading(false);
        resetForm();
        const resProducts = await fetch('https://kifli-api.onrender.com/api/products');
        const updatedProducts = await resProducts.json();
        setProducts(updatedProducts);
    };

    const resetForm = () => {
        setFormData({ title: '', description: '', price: 0, imageUrl: '' });
        setImageFile(null);
        setIsEditing(null);
        if(document.getElementById('image-upload')) {
            document.getElementById('image-upload').value = null;
        }
    };
    
    const handleEdit = (product) => {
        setIsEditing(product.id);
        setFormData(product);
        setMessage(`Editando: ${product.title}`);
    };

    return (
        <div className="bg-[#292929] p-8 rounded-lg space-y-6">
            <h2 className="text-2xl font-semibold text-white">{isEditing ? 'Actualizar Producto' : 'Crear Nuevo Producto'}</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input name="title" value={formData.title} onChange={handleFormChange} required className="input-field" placeholder="Título del Artículo" />
                <textarea name="description" value={formData.description} onChange={handleFormChange} className="input-field" placeholder="Descripción" />
                <input name="price" type="number" step="0.01" value={formData.price} onChange={handleFormChange} required className="input-field" placeholder="Precio" />
                <input name="image-upload" id="image-upload" type="file" onChange={handleImageChange} className="text-gray-400" disabled={isLoading} />
                {formData.imageUrl && !imageFile && <img src={formData.imageUrl} alt="Preview" className="w-20 h-20 object-cover rounded" />}
                
                <div className="flex gap-4">
                    <button type="submit" className="form-button bg-lime-400 text-black" disabled={isLoading}>{isEditing ? 'Actualizar' : (isLoading ? 'Creando...' : 'Crear')}</button>
                    {isEditing && <button type="button" onClick={resetForm} className="form-button bg-gray-600 text-white" disabled={isLoading}>Cancelar Edición</button>}
                </div>
            </form>
            {message && <p className="text-center text-white mt-4">{message}</p>}

            {/* Lista de productos para editar (sin cambios) */}
            <div className="border-t border-gray-700 pt-6">
                <h3 className="text-xl text-white mb-4">Productos Existentes</h3>
                <div className="space-y-2">
                    {products.map(p => (
                        <div key={p.id} className="flex justify-between items-center p-2 bg-[#222222] rounded">
                            <span className="text-gray-300">{p.title}</span>
                            <button onClick={() => handleEdit(p)} className="text-cyan-400 text-sm" disabled={isLoading}>Editar</button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ProductManager;